import jwtDecode from "jwt-decode";
import axios from "axios";
import { getPresignedUrlForFile } from "../helperApi/helperApi";
const backEndUrl = process.env.REACT_APP_API_ENDPOINT;
export const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur()

  // Prevent the page/container scrolling
  e.stopPropagation()

  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
    e.target.focus()
  }, 0)
}
export const getUserIdFromLocalStorage = () => {
  return localStorage.getItem("_id");
}
export const getUserCurrencyFromLocalStorage = () => {
  return localStorage.getItem("currency_meta");
}
export const validateUser = (navigate) => {
  let token = localStorage.getItem('Token');
  if (!token) {
    navigate('/');
    return false;
  } else {
    let decode = jwtDecode(token);
    if (decode.userType != "user") {
      return false;
    }
  }
  return true;
}

const currencyLocaleMap = {
  USD: "en-US",
  INR: "en-IN",
  EUR: "en-IE",
  GBP: "en-GB",
  AUD: "en-AU",
};


export const getCurrencyMeta = () => {
  try {
    return JSON.parse(localStorage.getItem("currency_meta"));
  } catch {
    return null;
  }
};


export const currencyFormatter = (amount) => {

  const currencyMeta = getCurrencyMeta();
  const currencyCode = currencyMeta?.code || "USD";
  const locale = currencyLocaleMap[currencyCode] || "en-US";

  // Fallbacks if meta is missing
  const precision = currencyMeta?.precision ?? 2;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(amount);
};

export const convertCustomerPriceToAdmin = (
  customerAmount,
  exchangeRate,
  decimals = 2
) => {
  if (
    typeof customerAmount !== "number" ||
    typeof exchangeRate !== "number" ||
    exchangeRate === 0
  ) {
    console.warn("Invalid Params");
    return 0;
  }

  // Derive customer → base rate (base is 1)
  const customerToBaseRate = 1 / exchangeRate;

  // Convert and round ONCE
  return Number((customerAmount * customerToBaseRate).toFixed(decimals));
};


export const convertAdminPriceToCustomer = (
  basePrice,
  exchangeRate,
  decimals = 2
) => {
  if (
    typeof basePrice !== "number" ||
    typeof exchangeRate !== "number"
  ) {
    console.warn('Invalid Params');
    return 0;
  }


  // Convert and round ONCE
  return Number((basePrice * exchangeRate).toFixed(decimals));
};


export const extractURLAndEncodedFilename = (url) => {
  const normalizedURL = url.replace(/[\\/]/g, '/');

  // Split the normalized URL by the last '/'
  const parts = normalizedURL.split('/');
  const filename = parts[parts.length - 1];

  // URL encode the extracted filename
  const encodedFilename = encodeURIComponent(filename.trim());

  // Extract the URL without the filename
  const urlWithoutFilename = normalizedURL.substring(0, normalizedURL.lastIndexOf('/') + 1);

  return {
    url: urlWithoutFilename,
    encodedFilename: encodedFilename
  };
}


export const checkIfAllPartsInvoicedForPO = (purchaseOrder) => {
  let localAvailableQtyData = {};
  purchaseOrder?.supplierRfqOfferId?.partsData?.forEach((lineItem) => {
    localAvailableQtyData[lineItem._id] = lineItem.qty;
  });
  purchaseOrder?.billsForPurchaseOrder?.forEach((item) => {
    item?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem.partItemId] =
        localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
    });
  });
  let listOfAvailableQtyValues = Object.values(localAvailableQtyData);
  let isAllQtyInvoiced = true;
  if (listOfAvailableQtyValues.some(item => item > 0)) {
    isAllQtyInvoiced = false;
  }
  return isAllQtyInvoiced;
}

export const getFileExtension = (filename) => {
  return filename?.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
}


export const isValidFileName = (name) => {
  const type = getFileExtension(name)?.toUpperCase();
  if (type === "STP" || type === "STEP" || type === "IGES" || type === "OBJ" || type === "STL") return true;
  return false;
}



export const downloadFileFromS3 = async (s3FileObject) => {
  try {
    if (!s3FileObject.bucket || !s3FileObject.key) {
      console.log("File details are missing. Please verify the file information or contact support for assistance.");
      return;
    }

    const signedUrl = await getPresignedUrlForFile(s3FileObject.bucket, s3FileObject.key);

    console.log('singedURl', signedUrl);
    if (!signedUrl) {
      console.log("Unable to retrieve the file. Please try again or contact support for further assistance.");
      return;
    }

    const link = document.createElement("a");
    link.href = signedUrl;
    link.download = s3FileObject.key.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Error downloading file:", err);
    console.log("An unexpected error occurred while downloading the file. Please try again or contact support.");
  }
};

export function calculateTaxAmount(price, taxPercent) {
  if (!price || !taxPercent) return 0;

  const amount = (Number(price) * Number(taxPercent)) / 100;

  return Number(amount.toFixed(2));
}

export const calculateTotalPriceWithTaxes = (
  item = {},
  taxes = []
) => {
  const base = Number(item?.price) * Number(item.qty);

  if (!Array.isArray(taxes) || taxes.length === 0) {
    return base;
  }

  const taxCount = taxes.length;

  const totalTax = Array.from({ length: taxCount }).reduce(
    (sum, _, index) => {
      const taxValue = Number(item?.[`tax${index + 1}`]) || 0;
      return sum + (base * taxValue) / 100;
    },
    0
  );

  return base + totalTax;
};
export const calculateTotalAmountFromParts = (
  partsData = [],
  taxes = []
) => {
  console.log("🔹 calculateTotalAmountFromParts called");
  console.log("Parts Data:", partsData);
  console.log("Taxes Meta (length only):", taxes);

  if (!Array.isArray(partsData) || partsData.length === 0) {
    console.log("⚠️ No parts data found. Returning 0.");
    return 0;
  }

  const taxCount = Array.isArray(taxes) ? taxes.length : 0;

  console.log("Number of taxes to apply:", taxCount);

  const total = partsData.reduce((grandTotal, part, index) => {
    const price = Number(part?.price) || 0;
    const qty = Number(part?.qty) || 0;

    const baseAmount = price * qty;

    console.log(`🔸 Part ${index + 1}`);
    console.log("  Price:", price);
    console.log("  Qty:", qty);
    console.log("  Base Amount:", baseAmount);

    if (taxCount === 0) {
      console.log("  No taxes applied for this part");
      return grandTotal + baseAmount;
    }

    // ✅ Read tax values from part.tax1, part.tax2, ...
    const taxAmount = Array.from({ length: taxCount }).reduce(
      (sum, _, taxIndex) => {
        const taxValue = Number(part?.[`tax${taxIndex + 1}`]) || 0;

        console.log(
          `  Tax ${taxIndex + 1}:`,
          taxValue,
          "%"
        );

        return sum + (baseAmount * taxValue) / 100;
      },
      0
    );

    console.log("  Total Tax Amount:", taxAmount);
    console.log("  Total With Tax:", baseAmount + taxAmount);

    const lineTotal = Number((baseAmount + taxAmount).toFixed(2));
    return grandTotal + lineTotal;
  }, 0);

  console.log("✅ Final Total Amount:", total);

  return total;
};


export const addBusinessDaysToMoment = (startDate, daysToAdd) => {
  let date = startDate.clone();
  let addedDays = 0;
  while (addedDays < daysToAdd) {
    date.add(1, 'days');
    if (date.day() !== 6) { // Skip Saturday
      addedDays++;
    }
  }
  return date;
};

export const calculateBillTotalAmount = (
  poPartsData = [],
  billPartsData = undefined,
  taxes = []
) => {
  if (!Array.isArray(poPartsData)) return 0;

  const updatedPartsData = poPartsData.map((part) => {
    let shippedQty = 0;
    if (Array.isArray(billPartsData)) {
      // For existing bills (array of parts)
      shippedQty =
        billPartsData.find(
          (item) =>
            item.partItemId?.toString() === (part._id || part.id)?.toString()
        )?.shippedQty || 0;
    } else if (typeof billPartsData === "object" && billPartsData !== null) {
      // For new bill creation (mapping partId -> qty)
      shippedQty = Number(billPartsData[part._id || part.id]) || 0;
    } else {
      // Fallback if billPartsData is not provided, use existing shippedQty/qty
      shippedQty = Number(part.shippedQty) || Number(part.qty) || 0;
    }
    return {
      ...part,
      qty: shippedQty,
    };
  });

  return calculateTotalAmountFromParts(updatedPartsData, taxes);
};

